import { t } from '@lingui/core/macro';
import { CommonMetadataAllowedValuesFilter } from './MetadataAllowedValuesFilter';
export const countryFilterLabel = () => t({ message: 'Country', comment: 'Insights filter: Country' });
export function CountryFilter() {
    return (<CommonMetadataAllowedValuesFilter name="Country" field="metadataDocumentCountry" label={countryFilterLabel()}/>);
}
